import React, { useEffect } from "react";
import Loader from "react-loaders";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

const QuickBooksLoadingModal = ({
  isLoading,
  error,
  navigateToQuickBooksPage,
}) => {
  const [showModal, setShowModal] = React.useState(false);

  useEffect(() => {
    setShowModal(isLoading);
  }, [isLoading]);

  const toggleModal = () => {
    setShowModal(!showModal);
  };

  const hasError = error !== undefined && error !== null && error !== "";

  return (
    <React.Fragment>
      <Modal
        size="md"
        isOpen={showModal}
        toggle={() => toggleModal()}
        backdrop="static"
      >
        <ModalHeader toggle={() => toggleModal()}>
          Loading QuickBooks
        </ModalHeader>
        <ModalBody>
          {!hasError && (
            <>
              <p>Syncing to QuickBooks, this might take a minute...</p>
              {isLoading && <Loader style={{}} type="ball-pulse" active />}
            </>
          )}
          {hasError && (
            <>
              <p>
                Error syncing to QuickBooks: {error}. Please Init QuickBooks
                again on the QuickBooks page.
              </p>
              {navigateToQuickBooksPage !== undefined && (
                <Button color="primary" onClick={navigateToQuickBooksPage}>
                  Go to QuickBooks Page
                </Button>
              )}
            </>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="link" onClick={toggleModal}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
};

export default QuickBooksLoadingModal;
